import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter, ViewChildren, QueryList } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { CuentasPorCobrarService } from '../../../services/cuentas-por-cobrar.service';
import { ConstantsService } from '../../../services/constants.service';
import { DetallesConvenioComponent } from './detalles-convenio/detalles-convenio.component';

declare var moment;

@Component({
  selector: 'app-modal-nuevo-convenio',
  templateUrl: './modal-nuevo-convenio.component.html',
  styleUrls: ['./modal-nuevo-convenio.component.scss']
})
export class ModalNuevoConvenioComponent implements OnInit {

  @ViewChild('content') private content: TemplateRef<any>;
  @Output() public aplicarDespuesDeActualizarConvenios:EventEmitter<any> = new EventEmitter;

  public modal: any = null;
  public convenio: any={};
  public cuentas_por_cobrar: any=[];
  public meses: any=['','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
  public loading:boolean=false;
  public error_message:string="";
  public editable:boolean=false;
  public autorizable:boolean=false;
  public api_url:string;

  public id_contrato:any;

  //Modelos
  public contrato: any= {};
  public cxc_rentas: any=[];

  //Helpers
  public fecha_inicio_contrato: string = null;
  public fecha_fin_contrato: string = null;
  public vistaActiva: string = 'rentas';

  constructor(public cuentas_por_cobrar_service:CuentasPorCobrarService, 
    private constant: ConstantsService, 
    private modalService: NgbModal) { }

  ngOnInit() {
    moment.locale('es');
    this.api_url = this.constant.apiURL;
  }

  public openModalNuevoConvenio(id_contrato, id_convenio, editable, autorizable) {
    this.editable = editable;
    this.autorizable = autorizable;
    this.loading = true;
    this.id_contrato = id_contrato;
    this.cuentas_por_cobrar_service.recuperarContratoParaConvenio(id_contrato)
    .subscribe(
      (response)=>{
        this.loading = false;
        let contrato = response.json().content;
        this.cxc_rentas = contrato.cxc_rentas;
        this.contrato = contrato;
        
        //Generar el objeto de descripción del convenio
        if(!id_convenio || id_convenio==null){
          this.crearConvenioVacio();
          this.configurarInformacionAdicionalContrato(contrato);
        }else{
          this.cuentas_por_cobrar_service.recuperarConvenio(id_convenio)
          .subscribe(
            (response)=>{
              this.loading = false;
              var res = response.json().content;
              //Realmente lo que debemos cargar es la especificacion
              this.convenio = res.especificacion_json;
              //Y le ponemos su id, comentarios y archivo
              this.convenio.id_convenio = res.id_convenio;
              this.convenio.comentarios = res.comentarios;
              this.convenio.documento_url = res.documento_url;
              this.convenio.documento_nombre = res.documento_nombre;
              this.convenio.input_file = undefined;
              //Calculos locales
            },
            (error)=>{
              this.loading = false;
            alert("ERROR:: "+JSON.stringify(error));
            }
          );
        }
    
      },
      (error)=>{
        this.loading = false;
        alert("ERROR:: "+JSON.stringify(error));
      }
    );
    
    let modal = this.modalService.open(this.content, { size: 'lg' });
    this.modal = modal;
  }

  private configurarInformacionAdicionalContrato(contrato: any){
    //Formatear las fechas del contrato
    this.fecha_inicio_contrato = moment(contrato.fecha_inicio,"YYYY-MM-DD HH:mm:ss").format('DD-MM-YYYY');
    this.fecha_fin_contrato = moment(contrato.fecha_fin,"YYYY-MM-DD HH:mm:ss").format('DD-MM-YYYY');
  }

  private crearConvenioVacio(){

    this.loading=false;
    this.convenio.vigencia_contrato=false;
    this.convenio.descuento_renta=false;
    this.convenio.diferir_renta=false;
    this.convenio.suspension_renta=false;

    //Primero, las rentas por cobrar (excluir las pasadas)
    var cambios = {};
    this.convenio.cambios = cambios;

    //Crear el arreglo que se utilizará para configurar el convenio sobre las rentas
    let rentas_por_cobrar = this.crearArregloCxcParaConvenio(this.contrato.cxc_rentas);
    this.convenio.cambios.rentas_por_cobrar = rentas_por_cobrar;
    this.convenio.configurar_rentas = { vigencia_contrato: false, descuento_renta: false, diferir_renta: false, copiar_convenio_renta: false};

    //Crear el arreglo que se utilizará para configurar el convenio sobre los mantenimientos
    if(this.contrato.cxc_mantenimientos.length > 0){
      let mantenimientos_por_cobrar = this.crearArregloCxcParaConvenio(this.contrato.cxc_mantenimientos);
      this.convenio.cambios.mantenimientos_por_cobrar = mantenimientos_por_cobrar;
    }
    this.convenio.configurar_mantenimientos = { vigencia_contrato: false, descuento_renta: false, diferir_renta: false, copiar_convenio_renta: false};

    //Crear el arreglo que se utilizará para configurar el convenio sobre los servicios
    if(this.contrato.cxc_servicios.length > 0){
      let servicios_por_cobrar = this.crearArregloCxcParaConvenio(this.contrato.cxc_servicios);
      this.convenio.cambios.servicios_por_cobrar = servicios_por_cobrar;
    }
    this.convenio.configurar_servicios = { vigencia_contrato: false, descuento_renta: false, diferir_renta: false, copiar_convenio_renta: false};
  }

  //Antes función crearRentas
  private crearArregloCxcParaConvenio(cxc_rentas){
    let rentas_por_cobrar=[];

    for(var i=0;i<cxc_rentas.length;i++){
      var cxc = cxc_rentas[i];
      
      if(this.esFutura(cxc.fecha_para_cobrar)){
        var fecha_date = moment(cxc.fecha_para_cobrar, "YYYY-MM-DD HH:mm:ss");
        cxc.periodo = this.nombreMes(fecha_date) + ' ' + fecha_date.format('YYYY');
        cxc.deleted = 0;
        cxc.descuento = 0;
        cxc.diferido_periodos = 0;
        cxc.diferido_porcentaje = 100;
        cxc.incremento_diferido = 0;
        cxc.diferido_control = false;
        cxc.diferir = false;
        cxc.importe = parseFloat(cxc.importe);
        //Colocarle a esta renta el arreglo de meses que estan por venir
        cxc.periodos_proximos = this.calcularPeriodosProximos(cxc, cxc_rentas);
        //Estas propiedades se agregan para aplicar los descuentos y diferidos
        cxc.importe_descuento = cxc.importe_sin_iva;
        cxc.importe_diferido = cxc.importe_sin_iva;
        
        rentas_por_cobrar.push(cxc);
      }
      
    }

    return rentas_por_cobrar;
  }

  calcularPeriodosProximos(periodo_actual,periodos){

    var proximos_periodos = [];
    var start_counting = false;
    var periodo_indice = 0;
    for(var i=0;i<periodos.length;i++){
      var periodo = periodos[i];
      if(start_counting){
        var fecha_date = moment(periodo.fecha_para_cobrar, "YYYY-MM-DD HH:mm:ss");
        var nombre_periodo = this.nombreMes(fecha_date) + ' ' + fecha_date.format('YYYY');
        proximos_periodos.push(
          {
            indice: periodo_indice,
            descripcion: nombre_periodo
          }
        );
        periodo_indice = periodo_indice+1;
      }else if(periodo.id_cuenta_por_cobrar==periodo_actual.id_cuenta_por_cobrar){
        start_counting=true;
      }

    }

    return proximos_periodos;
  }

  nombreMes(fecha_moment){
    return this.meses[parseInt(fecha_moment.format('MM'))];
  }

  esFutura(fecha){
    var fecha_date = moment(fecha, "YYYY-MM-DD HH:mm:ss");
    var now = moment();

    var es_futura = fecha_date>=now;
    return es_futura;
  }

  guardarConvenio(){
  
    this.error_message = '';
    if(!this.convenio.documento_url &&
      !this.convenio.input_file){
        this.error_message = "Por favor sube un archivo para tu convenio";
        return;
      }
    
    /* if(!this.convenio.diferir_renta && 
      !this.convenio.descuento_renta &&
      !this.convenio.vigencia_contrato){
        this.error_message = "Por favor selecciona alguna modificación a incluir en tu convenio";
        return;
      } */

    if(!this.convenio || !this.convenio.id_convenio || this.convenio.id_convenio==0){
      this.loading = true;
      //Guardar el convenio nuevo
      this.cuentas_por_cobrar_service.guardarConvenio(this.id_contrato, this.convenio)
      .subscribe(
        (response)=>{
          
          var id_convenio = response.json().content.id_convenio;
          this.convenio.id_convenio = id_convenio;
          
          if(this.convenio.input_file){
            this.cuentas_por_cobrar_service.subirArchivoConvenio(id_convenio, this.convenio)
            .subscribe(
              (responseUpload)=>{
                var content = responseUpload.json().content;
                var documento_url = content.archivo_url;
                var documento_nombre = content.nombre_archivo;
                this.convenio.documento_url = documento_url;
                this.convenio.documento_nombre = documento_nombre;
                this.cuentas_por_cobrar_service.actualizarConvenio(this.convenio)
                .subscribe(
                  (responseUpdate)=>{
                    this.loading = false;
                    this.cerrarModalYActualizarComponentePadre();
                  },
                  (errorUpdate)=>{
                    this.loading = false;
                    alert("ERROR al actualizar archivo: "+JSON.stringify(errorUpdate));
                  }
                );
              },
              (errorUpload)=>{
                this.loading = false;
                alert("ERROR al subir archivo: "+JSON.stringify(errorUpload));
              }
            );
          }else{
            this.loading = false;
            this.cerrarModalYActualizarComponentePadre();
          }
        },
        (error)=>{
          this.loading = false;
          alert("ERROR al crear convenio:: "+JSON.stringify(error));
        }
      );
      
    }else{
      //Actualizar el convenio
      this.loading = true;
      this.cuentas_por_cobrar_service.actualizarConvenio(this.convenio)
      .subscribe(
        (response)=>{

          if(this.convenio.input_file){
            this.cuentas_por_cobrar_service.subirArchivoConvenio(this.convenio.id_convenio, this.convenio)
            .subscribe(
              (responseUpload)=>{
                var content = responseUpload.json().content;
                var documento_url = content.archivo_url;
                var documento_nombre = content.nombre_archivo;
                this.convenio.documento_url = documento_url;
                this.convenio.documento_nombre = documento_nombre;
                this.cuentas_por_cobrar_service.actualizarConvenio(this.convenio)
                .subscribe(
                  (responseUpdate)=>{
                    this.loading = false;
                    this.cerrarModalYActualizarComponentePadre();
                  },
                  (errorUpdate)=>{
                    this.loading = false;
                    alert("ERROR al actualizar archivo: "+JSON.stringify(errorUpdate));
                  }
                );
              },
              (errorUpload)=>{
                this.loading = false;
                alert("ERROR al subir archivo: "+JSON.stringify(errorUpload));
              }
            );
          }else{
            this.loading = false;
            this.cerrarModalYActualizarComponentePadre();
          }
        },
        (error)=>{
          this.loading = false;
          alert("ERROR al crear convenio:: "+JSON.stringify(error));
        }
      );
    }
  }

  autorizarConvenio(){
    if(!confirm("¿Estás seguro de que deseas autorizar el convenio? Esta acción aplicará los cambios de este convenio al contrato folio "+this.id_contrato+" y afectará las cuentas por cobrar del mismo")) return;
    this.loading=true;
    this.cuentas_por_cobrar_service.autorizarConvenio(this.convenio)
      .subscribe(
        (response)=>{
          this.loading = false;
          this.cerrarModalYActualizarComponentePadre();
        },
        (error)=>{
          this.loading = false;
          alert("ERROR al autorizar convenio:: "+JSON.stringify(error));
        }
      );
  }

  public closeModal() {
    this.modal.close();
    this.convenio={};
  }

  public cerrarModalYActualizarComponentePadre() {
    this.modal.close();
    this.convenio={};
    if(this.aplicarDespuesDeActualizarConvenios){
      this.aplicarDespuesDeActualizarConvenios.emit();
    }
  }

  clickInput(input){
    document.getElementById(input).click();
  }

  onFileSelect(convenio, $event){
      if ($event.target.files.length > 0) {
          const file = $event.target.files[0];
          convenio.input_file = file;
          convenio.documento_nombre = file.name;
      }
  }

  eliminarArchivoInput(convenio, callback){
    convenio.loading = false;
    convenio.input_file = undefined;
    convenio.documento_loading = false;
    convenio.documento_nombre = undefined;
    convenio.documento_url = undefined;

    if(callback){
      callback();
    }
  }

  public seleccionaVistaConvenio(vista: string){
    this.vistaActiva = vista;
  }

  public cambiarAModoEdicion() {
    this.editable = true;
    this.autorizable = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/contratos/modal-nuevo-convenio/modal-nuevo-convenio.component.ts